// extracted by mini-css-extract-plugin
export var categoryLinks = "FooterContainer-module--categoryLinks--0029e";
export var categoryTitle = "FooterContainer-module--categoryTitle--7f45b";
export var divider = "FooterContainer-module--divider--f6727";
export var extraMargin = "FooterContainer-module--extraMargin--1ab8a";
export var footerBottom = "FooterContainer-module--footerBottom--bcef1";
export var footerBottomBar = "FooterContainer-module--footerBottomBar--149c3";
export var footerBottomContent = "FooterContainer-module--footerBottomContent--2daa5";
export var footerCategoriesData = "FooterContainer-module--footerCategoriesData--56fdd";
export var footerColumn = "FooterContainer-module--footerColumn--1e04a";
export var footerContainer = "FooterContainer-module--footerContainer--269e2";
export var footerContentContainter = "FooterContainer-module--footerContentContainter--e9939";
export var footerSocialLinks = "FooterContainer-module--footerSocialLinks--5dfa9";
export var linkSize = "FooterContainer-module--linkSize--73db1";
export var navContainer = "FooterContainer-module--navContainer--a63b0";
export var navContentContainer = "FooterContainer-module--navContentContainer--49b8d";
export var socialContentStyling = "FooterContainer-module--socialContentStyling--ed964";
export var socialIconsStyling = "FooterContainer-module--socialIconsStyling--aa695";
export var socialLabelStyling = "FooterContainer-module--socialLabelStyling--9e4d4";
export var socialTitle = "FooterContainer-module--socialTitle--ffac4";